// Bandeau d'accueil « Questionnaire ECF à compléter » (spec 010, FR-001, E12, A1) et compteur de la
// tuile (FR-002) : questionnaires au statut Sent (À compléter ou Brouillon).
import { EcfQuestionnaireSummary } from '@shared/models/ecf-questionnaire/ecf-questionnaire.model';

export type EcfBanner =
  | { kind: 'one'; societeName: string; dueDate: string; completedPoints: number; totalPoints: number; link: any[] }
  | { kind: 'many'; count: number; nearestDueDate: string; link: any[] };

export function pendingCount(questionnaires: EcfQuestionnaireSummary[] | null | undefined): number {
  return (questionnaires ?? []).filter(q => q.Status === 'Sent').length;
}

export function ecfBanner(questionnaires: EcfQuestionnaireSummary[] | null | undefined): EcfBanner | null {
  const pending = (questionnaires ?? []).filter(q => q.Status === 'Sent');
  if (pending.length === 0)
    return null;

  if (pending.length === 1) {
    const q = pending[0];
    return {
      kind: 'one', societeName: q.SocieteName, dueDate: q.DueDate,
      completedPoints: q.CompletedPoints, totalPoints: q.TotalPoints,
      link: ['/ecf/questionnaire', q.Id],
    };
  }

  // DueDate au format yyyy-MM-dd : l'ordre des chaînes est l'ordre des dates
  const nearestDueDate = pending.map(q => q.DueDate).sort()[0];
  return { kind: 'many', count: pending.length, nearestDueDate, link: ['/ecf/questionnaire'] };
}
